import { render, staticRenderFns } from "./user-cabinet.vue?vue&type=template&id=f8cd3f1c&scoped=true&"
import script from "./user-cabinet.vue?vue&type=script&lang=js&"
export * from "./user-cabinet.vue?vue&type=script&lang=js&"
import style0 from "./user-cabinet.vue?vue&type=style&index=0&id=f8cd3f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cd3f1c",
  null
  
)

export default component.exports